import { render, staticRenderFns } from "./SelectFromPlantings.html?vue&type=template&id=495f0ff5&scoped=true&external"
import script from "./SelectFromPlantings.ts?vue&type=script&lang=ts&external"
export * from "./SelectFromPlantings.ts?vue&type=script&lang=ts&external"
import style0 from "./SelectFromPlantings.css?vue&type=style&index=0&id=495f0ff5&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495f0ff5",
  null
  
)

export default component.exports